/**
 * A troca de caso na mesma montagem da página (E89.F2.C01, F-E89.F2-01).
 *
 * O React Router não remonta a página quando só o `:id` da rota muda. Tudo o
 * que a Pré-análise guarda em estado — o quadro, a peça aberta, os rascunhos,
 * a ação de caso em voo — continuava sendo do caso anterior. E a resposta que
 * chegasse tarde do caso anterior escrevia por cima do caso novo: o quadro de A
 * aparecia na tela de B, que é o RF05 pelo avesso.
 *
 * Duas coisas, e as duas precisam existir:
 *
 * - **Zerar no render, não num efeito.** Um efeito roda depois da pintura, e a
 *   tela de B mostraria o quadro de A uma vez antes de limpar.
 * - **O caso vigente em `ref`**, para toda continuação assíncrona conferir se
 *   ainda é dela a tela antes de escrever. Contador de leituras não basta: ele
 *   ordena leituras do MESMO caso, e a leitura de A pode ser a mais recente.
 */
import { useRef, useState, type MutableRefObject } from 'react';

export function useTrocaDeCaso(caseId: string, zerar: () => void): MutableRefObject<string> {
  const vigente = useRef(caseId);
  const [visto, setVisto] = useState(caseId);
  if (visto !== caseId) {
    setVisto(caseId);
    zerar();
  }
  vigente.current = caseId;
  return vigente;
}
